import { render, staticRenderFns } from "./RegNoDetail.vue?vue&type=template&id=3140388e"
import script from "./RegNoDetail.vue?vue&type=script&lang=js"
export * from "./RegNoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports